export default __webpack_public_path__ + "static/media/17.3baa7ce7.png";